import { ErrorScreenType, ErrorScreenConfig } from './error-screen.types';

export const ERROR_SCREEN_CONFIGS: Record<ErrorScreenType, ErrorScreenConfig> = {
  [ErrorScreenType.EVENT_NOT_FOUND]: {
    icon: 'event_busy',
    titleKey: 'errors.event_not_found_title',
    messageKey: 'errors.event_not_found_message',
    actionKey: 'errors.go_to_events',
    actionRoute: '/events',
  },
  [ErrorScreenType.ALBUM_NOT_FOUND]: {
    icon: 'photo_library',
    titleKey: 'errors.album_not_found_title',
    messageKey: 'errors.album_not_found_message',
    actionKey: 'errors.go_to_gallery',
    actionRoute: '/gallery',
  },
  [ErrorScreenType.PAGE_NOT_FOUND]: {
    icon: 'search_off',
    titleKey: 'errors.page_not_found_title',
    messageKey: 'errors.page_not_found_message',
    actionKey: 'errors.go_home',
    actionRoute: '/',
  },
  [ErrorScreenType.SERVER_ERROR]: {
    icon: 'error_outline',
    titleKey: 'errors.server_error_title',
    messageKey: 'errors.server_error_message',
    actionKey: 'errors.reload_page',
    isReload: true,
  },
  [ErrorScreenType.CHUNK_ERROR]: {
    icon: 'cloud_off',
    titleKey: 'errors.chunk_error_title',
    messageKey: 'errors.chunk_error_message',
    actionKey: 'errors.go_home',
    actionRoute: '/',
  },
};
